import { useEffect, useState } from 'react'
import { Salutation, WeatherWidget } from '@fullscreendigital/carrefour-dex-fe'
import { Chip, Grid } from '@mui/material'
import { Icon_v2 } from 'components/core-ui/Icon_v2'
import { useGetLocation, usePermissions, useNotification } from 'hooks'
import { useNavigate } from 'react-router-dom'
import { getUserFirstName } from '../../utils/authService'
import { roles } from './helpers'
import { SelectStoreModal } from './SelectStoreModal'
import { getShopReceptionShops } from '../Layout/api'
import s from '../ServiceDomain/ServiceDomain.scss'

const Home = ({ modules, setSubdomainId }) => {
  const navigate = useNavigate()

  const [selectedModule, setSelectedModule] = useState(null)
  const [isSelectStoreModalOpen, setIsSelectStoreModalOpen] = useState(false)

  const { showNotification } = useNotification()

  const { location, loading: isLocationLoading, error: isErrorGettingLocation } = useGetLocation()
  const username = getUserFirstName()

  const { canChooseStore } = usePermissions(roles)

  const selectedStoreCode = localStorage.getItem('selectedStoreCode')

  const { data: stores } = getShopReceptionShops(showNotification, canChooseStore)

  useEffect(() => {
    setSelectedModule(modules[0])
  }, [modules])

  useEffect(() => {
    if (canChooseStore) {
      openModal()
    }
  }, [canChooseStore])

  const openModal = () => setIsSelectStoreModalOpen(true)
  const closeModal = () => setIsSelectStoreModalOpen(false)

  return (
    <div className={s.modulePaper}>
      <Salutation name={username} />
      {isLocationLoading ? (
        <></>
      ) : (
        <WeatherWidget location={isErrorGettingLocation ? 'Bucuresti' : location} />
      )}

      {canChooseStore && stores?.length > 1 && !selectedStoreCode && (
        <SelectStoreModal
          isModalOpen={isSelectStoreModalOpen}
          closeModal={closeModal}
          stores={stores}
        />
      )}

      {modules.length ? (
        <Grid container direction="column">
          <Grid item style={{ marginTop: '16px' }}>
            <div>
              <span className={s.homeHeader}>Aplicatii</span>
              <span style={{ marginLeft: '8px' }}>
                <Icon_v2 iconName="Folder" iconType="Icon"></Icon_v2>
              </span>
            </div>
          </Grid>
          <Grid item style={{ marginTop: '16px' }}>
            <Grid container direction="row" spacing={2}>
              {modules.map((module, index) => (
                <Grid item key={module.id}>
                  <Chip
                    color={selectedModule?.id === module.id ? 'primary' : 'default'}
                    key={index}
                    label={module.name}
                    disabled={!!module.disabled}
                    onClick={() => {
                      if (module.disabled) {
                        showNotification({
                          message: 'Nu aveți niciun magazin asociat acestui cont.',
                          type: 'warning'
                        })
                        return
                      }
                      setSelectedModule(module)
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item style={{ marginTop: '16px' }}>
            <Grid container direction="row" spacing={4}>
              {selectedModule?.submodules.map(app => {
                const isDisabled = !!selectedModule?.disabled
                return (
                  <Grid item key={app.routeURL}>
                    <Grid
                      container
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      onClick={() => {
                        if (isDisabled) {
                          showNotification({
                            message: 'Nu aveți niciun magazin asociat acestui cont.',
                            type: 'warning'
                          })
                          return
                        }
                        localStorage.setItem('selectedSubdomainId', app.id)
                        setSubdomainId(app.id)
                        navigate(app.routeURL)
                      }}
                      aria-disabled={isDisabled}
                      title={isDisabled ? 'Nu aveți niciun magazin asociat acestui cont.' : undefined}
                    >
                      <Grid item>
                        <Icon_v2 iconName={app.icon} iconType="Home" />
                      </Grid>
                      <Grid item className={s.applicationName}>
                        <span>{app.name}</span>
                      </Grid>
                    </Grid>
                  </Grid>
                )
              })}

            </Grid>
          </Grid>
        </Grid>
      ) : (
        <div className={s.emptyWarning}>Nu aveti nici un modul asignat.</div>
      )}
    </div>
  )
}

export default Home
